import apiClient, { newCorrelationId } from "./apiClient";
import { TokenService } from "./tokenService";

/**
 * Envía al backend los errores de JavaScript (pantalla rota, promesa sin capturar) para que
 * queden en los logs / New Relic con tipo=FRONTEND, junto con la empresa y el usuario del token.
 * No reporta errores de llamadas HTTP: esos ya los registra el backend.
 */
const MAX_POR_MINUTO = 5;
const RECIENTES = new Map<string, number>();
let enviados: number[] = [];

const puedeEnviar = (clave: string): boolean => {
    const ahora = Date.now();
    enviados = enviados.filter((t) => ahora - t < 60_000);
    if (enviados.length >= MAX_POR_MINUTO) return false;
    const ultimo = RECIENTES.get(clave);
    if (ultimo && ahora - ultimo < 60_000) return false; // mismo error en el último minuto
    RECIENTES.set(clave, ahora);
    enviados.push(ahora);
    return true;
};

export const reportClientError = (origen: string, error: unknown): void => {
    try {
        // Sin sesión el backend rechazaría la llamada; los errores de red no se pueden reportar.
        if (!TokenService.getToken()) return;
        const e = error as any;
        if (e?.isAxiosError || e?.response || e?.isNetworkError) return;

        const mensaje = String(e?.message ?? e ?? "Error desconocido");
        const pila = String(e?.stack ?? "");
        if (!puedeEnviar(`${origen}|${mensaje}`)) return;

        apiClient
            .post(
                "/api/v1/errores/cliente",
                { origen, mensaje, pila, ruta: window.location.pathname },
                { headers: { "X-Correlation-Id": newCorrelationId() } }
            )
            .catch(() => undefined); // reportar nunca debe generar otro error
    } catch {
        /* nada: el reporte es de mejor esfuerzo */
    }
};

export const installGlobalErrorHandlers = (): void => {
    window.addEventListener("error", (ev) => {
        reportClientError("window.onerror", ev.error ?? ev.message);
    });
    window.addEventListener("unhandledrejection", (ev) => {
        reportClientError("unhandledrejection", ev.reason);
    });
};
